import React, {Component} from 'react';
import {LayoutComponent} from './LayoutComponent'

class LayoutContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			collapsed: true
		}
	}

	toggle = () => {
	this.setState({
		collapsed: !this.state.collapsed,
	});
};

	render() {
		const {collapsed} = this.state;
		return (
      <LayoutComponent collapsed={collapsed} toggle={this.toggle}/>
		);
	}
}

export default LayoutContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layout/LayoutContainer.js